import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';

export const DesignDetailsCard = ({ details }) => (
  <Card className="border-stone-taupe/20">
    <CardHeader>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <CardTitle className="text-charcoal-ink">Design Details — Order #{details.orderNumber}</CardTitle>
          <CardDescription>
            Submitted on {details.submittedAt ? new Date(details.submittedAt).toLocaleDateString() : '—'}
          </CardDescription>
        </div>
        <Badge className="bg-green-700 text-white">Submitted</Badge>
      </div>
    </CardHeader>
    <CardContent>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <p className="text-sm text-stone-taupe mb-1">Event Type</p>
          <p className="text-charcoal-ink font-medium capitalize">{(details.eventType || '').replace('-', ' ')}</p>
        </div>
        <div>
          <p className="text-sm text-stone-taupe mb-1">Event Date</p>
          <p className="text-charcoal-ink font-medium">{details.eventDate ? new Date(details.eventDate).toLocaleDateString() : '—'}</p>
        </div>
        <div>
          <p className="text-sm text-stone-taupe mb-1">Theme</p>
          <p className="text-charcoal-ink font-medium">{details.theme}</p>
        </div>
        <div>
          <p className="text-sm text-stone-taupe mb-1">Style</p>
          <p className="text-charcoal-ink font-medium capitalize">{(details.style || '').replace('-', ' ')}</p>
        </div>
      </div>

      <div className="mt-6 bg-soft-linen p-4 rounded-lg">
        <p className="text-charcoal-ink font-medium">Expected Timeline</p>
        <p className="text-stone-taupe text-sm mt-1">You can expect your first proof within 3–5 business days</p>
      </div>
    </CardContent>
  </Card>
);
